import { render, staticRenderFns } from "./messageLetterDeliveryResultList.vue?vue&type=template&id=7482b160"
import script from "./messageLetterDeliveryResultList.vue?vue&type=script&lang=js"
export * from "./messageLetterDeliveryResultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports